import { provideFetchPlanList } from '~/api-core/Subscription/Plan'

import type { Plan } from '~/types/Subscription'

function getBenefits(plan: Plan) {
  // mocked data for now
  return plan.interval === 'year'
    ? {
        'unlimited-hype': true,
        'unlimited-charts': true,
        'fifteen-percent-off': true,
        'exclusive-opportunities': true,
        'prioritized-team-support': true,
        'cancel-anytime': true,
      }
    : {
        'unlimited-hype': true,
        'unlimited-charts': true,
        'fifteen-percent-off': false,
        'exclusive-opportunities': true,
        'prioritized-team-support': true,
        'cancel-anytime': true,
      }
}
export const useSubscriptionStore = defineStore('subscription', () => {
  const { coreFetch } = useProvideCoreFetch()

  const plans = ref<Plan[]>([])
  const selectedPlanId = ref<Plan['id']>(0)

  async function FETCH_PLANS() {
    plans.value = (await provideFetchPlanList(coreFetch)()).map((plan) => ({
      ...plan,
      benefits: getBenefits(plan),
    }))
    if (plans.value.length > 0 && !selectedPlanId.value) {
      selectedPlanId.value =
        plans.value.find((plan) => plan.interval === 'year')?.id ??
        plans.value[0].id
    }
  }

  function GET_PLAN_BY_SLUG(slug: Plan['slug']) {
    return plans.value.find((plan) => plan.slug === slug)
  }

  function GET_PLAN_BY_STRIPE_ID(stripeId: Plan['stripe_id']) {
    return plans.value.find((plan) => plan.stripe_id === stripeId)
  }

  function SET_SELECTED_PLAN_ID(planId: Plan['id']) {
    selectedPlanId.value = planId
  }

  return {
    plans,
    selectedPlanId,

    FETCH_PLANS,
    GET_PLAN_BY_SLUG,
    GET_PLAN_BY_STRIPE_ID,
    SET_SELECTED_PLAN_ID,
  }
})
